import React, { useEffect, useState } from 'react';
import FilterDropdown from './FilterDropdown';
import ActionButtons from './ActionButtons';
import { useQueryBuilder } from '../context/QueryBuilderContext';
import {
  ASSET_SCAN_STATUS_ROUTE,
  FILTER_OPERATORS,
  SCAN_STATUS_FILTER_OPTIONS,
} from '../../../utils/constants';

interface ScanStatusFilterDropdownProps {
  closeDropdown: () => void;
}

const ScanStatusFilterDropdown: React.FC<ScanStatusFilterDropdownProps> = ({ closeDropdown }) => {
  const { setCondition, removeCondition, getConditionValue } = useQueryBuilder();
  const [selectedItems, setSelectedItems] = useState<string[]>([]);
  const [searchText, setSearchText] = useState('');
  const [filteredOptions, setFilteredOptions] = useState(SCAN_STATUS_FILTER_OPTIONS);

  useEffect(() => {
    const existing = getConditionValue(ASSET_SCAN_STATUS_ROUTE);
    const inValues = existing && (existing as Record<string, any>)[FILTER_OPERATORS.IN];
    if (Array.isArray(inValues)) {
      setSelectedItems(inValues);
    }
  }, []);

  useEffect(() => {
    const filtered = searchText.length
      ? SCAN_STATUS_FILTER_OPTIONS.filter((option) =>
          option.name.toLowerCase().includes(searchText.toLowerCase())
        )
      : SCAN_STATUS_FILTER_OPTIONS;
    setFilteredOptions(filtered);
  }, [searchText]);

  const clearAll = () => {
    setSelectedItems([]);
  };

  const applyFilter = () => {
    if (selectedItems.length > 0) {
      setCondition(ASSET_SCAN_STATUS_ROUTE, FILTER_OPERATORS.IN, selectedItems);
    } else {
      removeCondition(ASSET_SCAN_STATUS_ROUTE);
    }
    closeDropdown();
  };

  return (
    <div data-test-id="am-v2-scan-status-filter-dropdown">
      <input
        type="text"
        value={searchText}
        onChange={(e) => setSearchText(e.target.value)}
        placeholder="Search scan status..."
        style={{ width: '100%', padding: '8px', marginBottom: '8px', boxSizing: 'border-box' }}
      />

      <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
        <FilterDropdown
          data={filteredOptions}
          field="scan_status"
          selectedItems={selectedItems}
          setSelectedItems={setSelectedItems}
          loading={false}
        />
      </div>

      <ActionButtons
        closeDropdown={closeDropdown}
        clearAll={clearAll}
        applyFilter={applyFilter}
      />
    </div>
  );
};

export default ScanStatusFilterDropdown;